module.exports = "/_next/static/images/unlock-duotone-4594cb02e9d1a10ab21dd2f8889fc3df.svg";